import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceDirectiveDiagnosticEntryAdvanceProps {
  directiveEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceDirectiveDiagnosticEntryAdvance = ({
  directiveEntryId,
  options,
}: UseMaintenanceDirectiveDiagnosticEntryAdvanceProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceDirectiveDiagnosticEntryAdvance'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/directive/diagnostic_entries/${directiveEntryId}/advance`)
    },
    ...options,
  })
}
